export default __webpack_public_path__ + "static/media/autoconsumo-edificio.d20a3a56.png";